if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // const config = fetchConfig('javascript');
        // config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // delete config.headers['Content-Type'];

        let config = {};
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        // config.body = formData;

        const freeProduct = this.form.querySelector('[name=free-product-id]');
        const freeProductVariant = this.form.querySelector('[name=free-product-variant-id]');
        if (freeProductVariant != null && freeProductVariant.value != '') {
          config = fetchConfig();
          const payload = {
            items: [
              {
                id: this.form.querySelector('[name=id]').value,
                quantity: "1",
                properties: {
                  '_gift-child-product-id': this.form.querySelector('[name=free-product-variant-id]').value,
                }
              },
              {
                id: freeProductVariant.value,
                quantity: "1",
                properties: {
                  '_gift-product-id': this.form.querySelector('[name=free-product-variant-id]').value,
                  '_gift-parent-product-id': this.form.querySelector('[name=id]').value
                }
              }
            ]
          };
          for (const pair of formData.entries()) {
            if (pair[0] == 'quantity') {
              payload.items.forEach((item) => {
                item.quantity = pair[1];
              });
            }

            if (pair[0] == 'id' || pair[0] == 'quantity' || pair[0] == 'product-id') continue;
            payload[pair[0]] = pair[1]
          }
          config.body = JSON.stringify(payload);
        } else if (freeProduct) {
          config = fetchConfig();
          const payload = {
            items: [
              {
                id: this.form.querySelector('[name=id]').value,
                quantity: "1",
                properties: {
                  '_gift-child-product-id': this.form.querySelector('[name=free-product-id]').value,
                }
              },
              {
                id: freeProduct.value,
                quantity: "1",
                properties: {
                  '_gift-product-id': this.form.querySelector('[name=free-product-id]').value,
                  '_gift-parent-product-id': this.form.querySelector('[name=id]').value
                }
              }
            ]
          };
          for (const pair of formData.entries()) {
            if (pair[0] == 'quantity') {
              payload.items.forEach((item) => {
                item.quantity = pair[1];
              });
            }

            if (pair[0] == 'id' || pair[0] == 'quantity' || pair[0] == 'product-id') continue;
            payload[pair[0]] = pair[1]
          }
          config.body = JSON.stringify(payload);
        } else {
          config = fetchConfig("javascript");
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              console.log('test', soldOutMessage)
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)

              // if (freeProduct) {
              //   console.log('form', this.form)
              //   const formProduct = {
              //     'id': this.form.querySelector('[name=free-product-id]').value,
              //     properties: {
              //       '_gift-product-id': this.form.querySelector('[name=free-product-id]').value,
              //       '_gift-parent-product-id': this.form.querySelector('[name=id]').value
              //     },
              //     'quantity': 1,
              //     'sections': this.cart.getSectionsToRender().map((section) => section.section),
              //     'sections_url': window.location.pathname,
              //   }
              //   fetch('/cart/add.js', {
              //     method: 'POST',
              //     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              //     body: JSON.stringify(formProduct)
              //   })
              //     .then(response => response.json())
              //     .then(data => {
              //       this.onDrawerCartUpdate()
              //     });
              // }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const soldOutMessage = document.getElementById('free-product-variant-message-sold-out');
              console.log('test', response.errors)
              if (response.errors) {
                console.log('entra')
                soldOutMessage.innerHTML = '<strong>Peso agotado para esta Navidad</strong>'
                soldOutMessage.classList.remove('hidden');
              }
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      onDrawerCartUpdate() {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.drawer__inner');
            document.querySelector('cart-drawer').classList.remove('is-empty');
            document.querySelector('.drawer__inner').innerHTML = sourceQty.innerHTML;
            console.log('__UI', localStorage.getItem('__ui'));
            if (localStorage.getItem('__ui'))
              localStorage.removeItem('__ui')
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
